import { API } from 'aws-amplify';
import { USER_API_GATEWAY_ENDPOINT_NAME } from '../../../../../aws-exports';

export async function changeEmail({ oldEmail, newEmail }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/user-subscription/change-email',
    { body: { oldEmail, newEmail } }
  );
  return response;
}

// Change Student Cohort
export async function changeCohort(body) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/user-subscription/change-cohort',
    { body }
  );
  return response;
}

// Update Student Name
export async function updateStudentName({ userId, userObj }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/student/updateName',
    { body: { userId, userObj } }
  );
  return response;
}

// Remove Student Phone
export async function removeStudentPhone({ userId }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/student/removePhone',
    { body: { userId } }
  );
  return response;
}

// Pause Student (Archive)
export async function pauseStudent({ userId, course }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/student/pause',
    { body: { userId, course } }
  );
  return response;
}

// Start Student (Unpause/Unarchive)
export async function startStudent({ userId, course }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/student/start',
    { body: { userId, course } }
  );
  return response;
}

// Unenroll Student
export async function unenrollStudent({ userId, course }) {
  const response = await API.post(
    USER_API_GATEWAY_ENDPOINT_NAME,
    '/api/admin/student/unenroll',
    { body: { userId, course } }
  );
  return response;
}
